// Generated from the Upzi DLS Figma icon library by sync-dls-icons.mjs.
import { createDlsIcon } from './dls-icon';

const ExpandArrowIcon = createDlsIcon('ExpandArrowIcon', {
  filled: (
    <>
      <path
        d="M41.5857 12.5857L23.9998 30.1718L6.41375 12.5857C5.63275 11.8047 4.36675 11.8047 3.58575 12.5857C2.80475 13.3668 2.80475 14.6327 3.58575 15.4137L22.5858 34.4138C22.9768 34.8048 23.4878 34.9998 23.9998 34.9998C24.5117 34.9998 25.0227 34.8048 25.4137 34.4138L44.4137 15.4137C45.1947 14.6327 45.1947 13.3668 44.4137 12.5857C43.6328 11.8047 42.3667 11.8047 41.5857 12.5857Z"
        fill="currentColor"
      />
    </>
  ),
  outline: (
    <>
      <path
        d="M42.0858 12.0858C42.8668 11.3047 44.1329 11.3047 44.9139 12.0858C45.695 12.8668 45.695 14.1329 44.9139 14.9139L25.4139 34.4139C24.6329 35.195 23.3668 35.195 22.5858 34.4139L3.08579 14.9139C2.30474 14.1329 2.30474 12.8668 3.08579 12.0858C3.86683 11.3047 5.13286 11.3047 5.91391 12.0858L23.9998 30.1717L42.0858 12.0858Z"
        fill="currentColor"
      />
    </>
  ),
});

export { ExpandArrowIcon };
export default ExpandArrowIcon;
